import { ScrollView } from 'react-native';
import { Box } from '@/components/ui/primitives';
import AppHeader from '@/components/AppHeader';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { useLeagueContext } from '@/contexts/LeagueContext';
import PaymentManagement from '@/components/PaymentManagement';
import { leagueRouteStyles } from '@/components/route/leagueRouteStyles';

export default function LeaguePaymentsRoute() {
  const context = useLeagueContext();

  const {
    id,
    resolvedSeasonId,
    league,
  } = context;

  const headerTitle = league?.name ?? 'League';

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        <ScrollView style={leagueRouteStyles.flex} contentContainerStyle={leagueRouteStyles.content}>
          <PaymentManagement
            leagueId={id}
            seasonId={resolvedSeasonId ?? undefined}
          />
        </ScrollView>
      </Box>
    </NativeTabFocusGate>
  );
}
